import React, { useRef } from 'react';

import styles from './ProgressBar.module.css'

interface ProgressBarProps {
  playerRef: React.RefObject<HTMLMediaElement | null>;
  totalDuration: number;
  progress: number;
  setProgress?: (progress: number) => void;
  onSeek: (time: number) => void;
}

const ProgressBar: React.FC<ProgressBarProps> = ({playerRef, totalDuration, progress, setProgress, onSeek}) => {
    const seekStartRef = useRef<number | null>(null)

    const handleMouseDown = () => {
        seekStartRef.current = progress
    }

    const handleMouseUp = () => {
        seekStartRef.current = null;
    };

    return (
        <div className={styles.progressBar}>
            <input
                type='range'
                max={totalDuration}
                value={progress}
                onInput={(event: React.FormEvent<HTMLInputElement>) => onSeek(Number((event.target as HTMLInputElement).value))}
                onMouseUp={handleMouseUp}
                onMouseDown={handleMouseDown}
            />            
        </div>
    );
};

export default ProgressBar;
